import { render } from "./AllArchivedProducts.vue?vue&type=template&id=63d0b61d"
import script from "./AllArchivedProducts.vue?vue&type=script&lang=js"
export * from "./AllArchivedProducts.vue?vue&type=script&lang=js"

import "./AllArchivedProducts.vue?vue&type=style&index=0&id=63d0b61d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__